/**
 * Route for `fbclid-msclkid-ttclid-parallel-tracking-cross-netw`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { FbclidMsclkidTtclidParallelTrackingCrossNetwPage } from "../features/fbclid-msclkid-ttclid-parallel-tracking-cross-netw/FbclidMsclkidTtclidParallelTrackingCrossNetwPage";

export const fbclidMsclkidTtclidParallelTrackingCrossNetwRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/fbclid-msclkid-ttclid-parallel-tracking-cross-netw",
	component: FbclidMsclkidTtclidParallelTrackingCrossNetwPage,
});

export default fbclidMsclkidTtclidParallelTrackingCrossNetwRoute;
